export default __webpack_public_path__ + "static/media/47_mobile.228c8ac2.jpg";